<template>
  <VCard class="payment-baemin-point-wrapper">
    <VBlock class="payment-baemin-point" :sort="Sort.space_between">
      <VSpan text="배민포인트" :size="16" :spacing="-0.35" :color="TextColor.darkGray" />
      <VA :onClick="onBaeminPoint" class="baemin-point-button">
        <VSpan
          v-show="baeminPoint.use"
          class="detail"
          :type="TextType.Number"
          :text="`- ${baeminPoint.spentAmount}원`"
          :size="14"
          :color="TextColor.gray"
          :spacing="-0.35"
        />
        <VBlock>
          <VSpan
            v-show="!baeminPoint.use"
            class="detail"
            :type="TextType.Number"
            :text="textAtNotUseBaeminPoint"
            :size="14"
            :spacing="-0.35"
            :color="TextColor.gray2"
          />
          <div class="image-wrapper">
            <img :src="resources.foldIcon" :style="{ transform: 'rotate(-90deg)' }" />
          </div>
        </VBlock>
      </VA>
    </VBlock>
  </VCard>
</template>

<script>
import VBlock, { Direction, Sort } from '../../molecules/VBlock/index'
import VSpan, { TextColor, TextType } from '../../atoms/VSpan/index'
import VA from '../../molecules/VA/index'
import VCard, { ColorType } from '../../molecules/VCard/index'

import foldIcon from '@/assets/images/fold-icon.svg'

export default {
  name: 'PreOrderBaeminPoint',
  components: { VA, VSpan, VBlock, VCard },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    maximumUsableBaeminPoint: {
      type: Number,
      required: true
    },
    baeminPoint: {
      type: Object,
      required: true
    },
    onBaeminPoint: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      Direction,
      Sort,
      TextColor,
      TextType,
      ColorType,

      resources: {
        foldIcon
      }
    }
  },
  computed: {
    usableBaeminPoint() {
      return Math.min(this.maximumUsableBaeminPoint, this.baeminPoint.availableAmount)
    },

    textAtNotUseBaeminPoint() {
      if (this.baeminPoint.availableAmount <= 0) {
        return `${this.usableBaeminPoint}원`
      }

      return `${this.usableBaeminPoint}원 사용가능`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.payment-baemin-point-wrapper {
  width: 100%;
  height: 60px;
  margin-bottom: 10px;
  /* border-top: 1px solid $background-gray; */
  border-bottom: 1px solid $light-gray-5;

  .payment-baemin-point {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 21px 15px 19px;
    align-items: center;

    .baemin-point-button {
      display: flex;
      justify-content: center;
      align-items: center;
      .image-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 22px;
        padding-bottom: 1px;
      }
    }

    .detail {
      margin-right: 4px;
      vertical-align: middle;
    }
  }
}
</style>
